

export default function translateFromArray<T extends { locale: string }>({lang, translations}: {lang: string, translations: Array<T>}): T | undefined {
    return translations?.find(translation => translation.locale === lang);
}